import React from "react";
import { PropTypes } from "prop-types";
import { motion } from "framer-motion";

const fadeIn = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
  },
};

const slideIn = {
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      x: { stiffness: 1000, velocity: -10 },
    },
  },
  hidden: {
    x: 350,
    opacity: 0,
    transition: {
      x: { stiffness: 1000 },
    },
  },
  initial: {
    x: 350,
    opacity: 0,
    transition: {
      x: { stiffness: 1000 },
    },
  },
  exit: {
    x: 350,
    opacity: 0,
    transition: {
      x: { stiffness: 1000 },
    },
  },
};

const AnimationWrapper = (props) => {
  const { children, animationIn, duration, overflow } = props;
  let variants = fadeIn;
  let animationStyle = {};

  switch (animationIn) {
    case "fadeIn":
      variants = fadeIn;
      animationStyle = { willChange: "opacity" };
      break;
    case "slideIn":
      variants = slideIn;
      animationStyle = { willChange: "transform" };
      break;
    default:
      variants = fadeIn;
      animationStyle = { willChange: "opacity" };
      break;
  }

  return (
    <motion.div
      style={{
        overflow: overflow ? "auto" : "initial",
        ...animationStyle,
      }}
      initial="hidden"
      animate="visible"
      variants={variants}
      transition={{ duration: duration || 1 }}
    >
      {children}
    </motion.div>
  );
};

AnimationWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  animationIn: PropTypes.string,
  duration: PropTypes.number,
};

export default AnimationWrapper;
